export const sendEventLog = (name, log) => {
  //FS (full story)
  const fsClient = window.FS;
  const sessionId = sessionStorage?.getItem("sessionId") || "";
  const companyName = localStorage?.getItem("companyName") || "";
  log.session_id = sessionId;
  log.customer_type = companyName;

  if (fsClient) {
    try {
      fsClient.event(name, log);
      console.log(
        `%c Success on fs.event - ${name} `,
        "background-color: green; color: #000"
      );
    } catch (ex) {
      console.log(
        `%c Exception on fs.event - ${name} `,
        "background-color: red; color: #000"
      );
    }
  } else {
    console.log(
      `%c fs not found - ${name} `,
      "background-color: red; color: #000"
    );
  }
};